import * as React from 'react';
import { cn } from '@/lib/utils';

export interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {}

const Input = React.forwardRef<HTMLInputElement, InputProps>(({ className, type, ...props }, ref) => {
  return (
    <input
      type={type}
      ref={ref}
      className={cn(
        'flex h-11 w-full rounded-md border border-bone-deep bg-surface px-3.5 py-2 text-sm text-ink placeholder:text-ink-muted',
        'transition-[border-color,box-shadow] duration-200 ease-out',
        'focus:border-accent-glow focus:outline-none focus:ring-2 focus:ring-accent-glow focus:ring-offset-0',
        'disabled:cursor-not-allowed disabled:opacity-50',
        className,
      )}
      {...props}
    />
  );
});
Input.displayName = 'Input';

export { Input };
